import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import queryString from 'query-string';
import {
  fetchIpList,
  ipItemsAdded,
  ipItemsRemoved,
  saveAndFetchAllPcSlots,
  ipMemoChanged,
} from '../../../../actions/ipManagement.actions';
import {fetchIdentificationWithRequestTokenOrRedirectOnFail} from '../../../../actions/identification.actions';
import natsort from 'natsort';
import validateip from 'validate-ip';
import {getPublicGameTitle} from '../../../../constants/gameType.constants';
import './index.scss';
import Button from '../../../Common/Button';
import ButtonGroup from '../../../Common/ButtonGroup';
import {BulletList, PageContainer, PageTitle} from '../../../Common/PageComponents';
import PageDescription from '../../../Common/PageDescription';
import Table from '../../../Common/Table';

const stateToProps = state => {
  return {
    user: state.user,
    ipManagement: state.ipManagement,
  };
};

const MAX_IP_COUNT = 500;

class IpManagement extends Component {
  constructor() {
    super();

    this.state = {
      filterActive: false,
    };
  }

  componentDidMount() {
    this.props.dispatch(fetchIpList());

    if (this.props.user.useIdentityVerificationOnIpManagement) {
      let requestParams = queryString.parse(window.location.search);
      this.props.dispatch(
        fetchIdentificationWithRequestTokenOrRedirectOnFail(
          requestParams.identityToken,
          '/my-pc-bang/management/ip-management/identification',
          this.props.history,
          '',
          this.props.user.duplicationInformation
        )
      );
    }
  }

  checkIfChangesAreSaved() {
    if (this.props.ipManagement.dirty) {
      let saveOrExit = confirm('변경 사항이 동록 완료 되지 않았습니다.\n변경 사항을 등록 완료 하시겠습니까?');
      if (saveOrExit) {
        this.props.dispatch(saveAndFetchAllPcSlots(this.props.ipManagement.pcSlots));
      }
    }
  }

  componentWillUnmount() {
    this.checkIfChangesAreSaved();
  }

  _onChangeActiveStatusFilter() {
    let filterActive = false;
    if (this.filterSelect.value === 'onlyActive') {
      filterActive = true;
    }

    this.setState({
      filterActive,
    });
  }

  _checkAll() {
    let checked = this.form.allCheckBox.checked;

    if (this.form.itemCheckBox.length === undefined) {
      this.form.itemCheckBox.checked = checked;
    } else {
      for (let i = 0; i < this.form.itemCheckBox.length; i++) {
        this.form.itemCheckBox[i].checked = checked;
      }
    }
  }

  _deleteCheckedIpAddresses(e) {
    e.preventDefault();

    let rows = this.form.querySelectorAll('tbody tr');

    let checkedRowsCount = 0;
    for (let i = 0; i < rows.length; i++) {
      let itemCheckBox = rows[i].querySelector('input[name=itemCheckBox]');
      if (itemCheckBox.checked) {
        checkedRowsCount++;
      }
    }

    if (!checkedRowsCount) {
      alert('삭제할 IP를 선택해주세요.');
      return;
    }

    if (!confirm('선택한 IP를 삭제하시겠습니까?')) {
      return;
    }

    let ipsToBeRemoved = [];
    for (let i = 0; i < rows.length; i++) {
      let itemCheckBox = rows[i].querySelector('input[name=itemCheckBox]');
      if (itemCheckBox.checked) {
        ipsToBeRemoved.push(itemCheckBox.value);
      }
    }

    this.props.dispatch(ipItemsRemoved(ipsToBeRemoved));
    this.form.allCheckBox.checked = false;

    alert('삭제되었습니다.\n최종 IP 목록을 반영하려면 등록완료 버튼을 눌러주세요.');
  }

  _isIpAddressDigit(value) {
    return value.match(/^[0]$/) || value.match(/^[1-2][0-9]{0,2}/);
  }

  _filterIpAddressInput(e) {
    let key = e.key;

    if (!key.match(/[0-9]/)) {
      e.preventDefault();
    }
  }

  _alertAndFocusInputBoxIfEmpty(inputs) {
    for (let i = 0; i < inputs.length; i++) {
      let input = inputs[i];
      if (!input.value && input.value !== 0) {
        alert('IP 대역을 모두 채워주세요.');
        input.focus();
        return true;
      }
    }
    return false;
  }

  _insertIpsWithRange(e) {
    e.preventDefault();

    if (!validateip(this.ipv4Input.value)) {
      alert('IP 주소 형식이 잘못되었습니다. 다시 확인해 주세요.');
      this.ipv4Input.focus();
      return;
    }

    if (this._alertAndFocusInputBoxIfEmpty([this.ipv4Input, this.ipRangeInput])) {
      return;
    }

    let splitedIpv4 = this.ipv4Input.value.split('.');
    let ipPostfix = splitedIpv4[3];

    if (parseInt(this.ipRangeInput.value) < parseInt(ipPostfix)) {
      alert('IP 대역의 마지막 칸의 숫자가 직전 칸의 숫자보다 작거나 같아야 합니다.');
      this.ipRangeInput.focus();
      return;
    }

    let ipPrefix = `${splitedIpv4[0]}.${splitedIpv4[1]}.${splitedIpv4[2]}.`;

    let ipsToBeAdded = [];
    for (let lastIp = parseInt(ipPostfix); lastIp <= parseInt(this.ipRangeInput.value); lastIp++) {
      let ipToBeAdded = ipPrefix + lastIp;
      ipsToBeAdded.push({
        identificationValue: ipToBeAdded,
        memo: '',
        createdAt: moment().toISOString(),
      });
    }
    this.props.dispatch(ipItemsAdded(ipsToBeAdded));

    this.ipv4Input.value = '';
    this.ipRangeInput.value = '';

    this.setState({
      filterActive: false,
    });

    this.filterSelect.value = 'all';
  }

  _saveAll(e) {
    e.preventDefault();

    if (this.props.ipManagement.pcSlots.length > MAX_IP_COUNT) {
      alert('등록 가능한 최대 IP 개수는 500개 입니다.');
      return;
    }

    this.props.dispatch(saveAndFetchAllPcSlots(this.props.ipManagement.pcSlots));
  }

  _updateMemo(e, identificationValue) {
    this.props.dispatch(ipMemoChanged(identificationValue, e.target.value));
  }

  static renderGameTitlesOfActiveSessions(activeSessions) {
    const distinctGameTitles = new Set(activeSessions.map(session => getPublicGameTitle(session.gameType)));
    return Array.from(distinctGameTitles).map(title => <div key={title}>{title}</div>);
  }

  render() {
    let pcSlots = this.props.ipManagement.pcSlots;
    let sorter = natsort();
    pcSlots.sort((a, b) => {
      return sorter(a.identificationValue, b.identificationValue);
    });

    return (
      <PageContainer>
        <PageTitle title="IP 관리" data-qa="usagePageTitle" />
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
          <PageDescription>
            ※ 게임접속여부는 동기화 문제로 접속 2분 뒤부터 접속중으로 표기됩니다.
            <br />
            (과금은 접속 시점부터 정상적으로 진행됩니다)
          </PageDescription>
          <div>
            <select ref={select => (this.filterSelect = select)} onChange={() => this._onChangeActiveStatusFilter()}>
              <option value="all">전체 IP 리스트</option>
              <option value="onlyActive">접속중인 IP 리스트</option>
            </select>
          </div>
        </div>
        <form ref={form => (this.form = form)}>
          <Table>
            <colgroup>
              <col width={38} />
              <col width={160} />
              <col width={350} />
              <col width={160} />
            </colgroup>
            <thead>
              <tr>
                <th style={{verticalAlign: 'middle'}}>
                  <input type="checkbox" name="allCheckBox" onClick={() => this._checkAll()} />
                </th>
                <th>IP주소</th>
                <th>메모</th>
                <th>게임접속여부</th>
                <th>변경일자</th>
              </tr>
            </thead>
            <tbody id="ipList" ref={tbody => (this.ipList = tbody)}>
              {pcSlots.length > 0
                ? pcSlots.map(pcSlot => {
                    if (this.state.filterActive && !pcSlot.billingActive) {
                      return null;
                    }

                    return (
                      <tr key={pcSlot.identificationValue} className="pc-slot-info">
                        <td className="end">
                          <input type="checkbox" name="itemCheckBox" defaultValue={pcSlot.identificationValue} />
                        </td>
                        <td style={{textAlign: 'left'}}>
                          <p name="ipAddress">{pcSlot.identificationValue}</p>
                        </td>
                        <td>
                          {' '}
                          <input
                            type="text"
                            name="memo"
                            maxLength={20}
                            style={{width: '350px'}}
                            defaultValue={pcSlot.memo}
                            onChange={e => this._updateMemo(e, pcSlot.identificationValue)}
                          />
                        </td>
                        <td>
                          {pcSlot.billingActive
                            ? IpManagement.renderGameTitlesOfActiveSessions(pcSlot.activeBillingSessions)
                            : '접속안함'}
                        </td>
                        <td className="end">{moment(pcSlot.createdAt).format('YYYY/MM/DD')}</td>
                      </tr>
                    );
                  })
                : null}
            </tbody>
          </Table>
        </form>
        <ButtonGroup>
          <Button className="ip-manage-button" size="small" onClick={e => this._saveAll(e)} data-qa="confirmButton">
            등록 완료
          </Button>
          <Button
            className="ip-manage-button"
            size="small"
            onClick={e => this._deleteCheckedIpAddresses(e)}
            data-qa="removeButton"
          >
            선택 IP 삭제
          </Button>
          <Button
            className="ip-manage-button"
            size="small"
            theme="gray"
            onClick={() => location.reload()}
            data-qa="removeButton"
          >
            취소
          </Button>
        </ButtonGroup>
        <div id="ipRangeFill">
          <PageDescription>IP 추가하기</PageDescription>
          <div style={{marginBottom: '10px'}}>
            <input
              ref={input => (this.ipv4Input = input)}
              type="text"
              autoComplete="off"
              className="input_text"
              style={{width: '400px'}}
              data-qa="ipInputbox1"
            />
            &nbsp;~&nbsp;&nbsp;
            <input
              ref={input => (this.ipRangeInput = input)}
              type="text"
              autoComplete="off"
              className="input_text"
              maxLength="3"
              style={{padding: '5px', width: '92px'}}
              onKeyPress={e => this._filterIpAddressInput(e)}
              data-qa="ipInputbox5"
            />
            <Button
              className="ip-manage-button"
              theme="gray"
              size="small"
              onClick={e => this._insertIpsWithRange(e)}
              data-qa="ipFillButton"
            >
              IP 대역 채우기
            </Button>
          </div>
        </div>
        <BulletList
          style={{
            border: '1px solid #E7E7E7',
            color: '#404040',
            padding: '10px 20px',
            marginTop: '45px',
            fontSize: '12px',
            letterSpacing: '-1px',
          }}
        >
          <ul>
            <li>
              <strong>중요: 아이피 대역 채우기 후 등록 완료 버튼을 눌러야 IP가 등록 완료됩니다.</strong>
            </li>
            <li>IP개수는 500개 이하까지 등록 가능합니다. 단, 정확한 IP주소를 입력하여 주시기 바랍니다.</li>
            <li>등록된 IP를 기준으로 프리미엄 서비스가 제공되니 입력에 주의하시기 바랍니다.</li>
          </ul>
        </BulletList>
      </PageContainer>
    );
  }
}

export default connect(stateToProps)(IpManagement);
